import React from 'react';
import compose from 'lodash/fp/compose';
import { withMetrics } from '@catalogo/core-metrics';

const filters = {
  likes: 'ordenar por respostas mais úteis',
  descending: 'ordenar por mais recentes',
  ascending: 'ordenar por mais antigos',
};

export const withFilter = Component => ({ fetchMore, offset, limit, total, dispatchMetrics }) => {
  const onChange = e => {
    dispatchMetrics('event:track', {
      category: 'product',
      action: 'Q&A - Filtro',
      label: filters[e.target.value],
    });

    fetchMore({
      limit: offset + limit >= total ? total : offset + limit,
      offset: 0,
      sort: e.target.value,
      hasChangedOrder: true,
      loadingTarget: 'all',
    });
  };

  return <Component onChange={onChange} />;
};
export default compose(withMetrics, withFilter);
